import AuthApi from './AuthApi';
import UserApi from './UserApi';
import TreeApi from './TreeApi';
import ReportsApi from './ReportsApi';
import FinanceApi from './FinanceApi';
import BetHistoryApi from './SportHistoryApi';
import AgentAdminApi from './AgentAdminApi';
import CbuPaymentsApi from './CbuPaymentsApi';
import StatisticApi from './StatisticApi';
import BonusProgramApi from './BonusProgramApi';

class Api {
  constructor(baseUrl = '') {
    this.auth = new AuthApi(baseUrl);
    this.user = new UserApi(baseUrl);
    this.tree = new TreeApi(baseUrl);
    this.reports = new ReportsApi(baseUrl);
    this.finance = new FinanceApi(baseUrl);
    this.sportHistory = new BetHistoryApi(baseUrl);
    this.agentAdmin = new AgentAdminApi(baseUrl);
    this.cbuPayment = new CbuPaymentsApi(baseUrl);
    this.statistic = new StatisticApi(baseUrl);
    this.bonusProgram = new BonusProgramApi(baseUrl);
  }
}

export default Api;
